import avatar from "assets/img/avatars/avatar11.png";
import banner from "assets/img/profile/banner.png";
import Card from "components/card";

const Banner = () => {
  return (
    <Card extra={"items-center w-full h-full p-[16px] bg-cover"}>
      {/* Background and profile */}
      <div
        className="relative mt-1 flex h-32 w-full justify-center rounded-xl bg-cover"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] border-white bg-blue-400 dark:!border-navy-700">
          <img className="h-full w-full rounded-full" src={avatar} alt="" />
         


        </div>
      </div>

  

      {/* Name and position */}
      <div className="mt-16 flex flex-col items-center">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          Cesar Alvarez
        </h4>
        <p className="text-base font-normal text-gray-600">Ingeniero de Sistemas</p>
      </div>

      {/* Post followers */}
      <div className="mt-6 mb-3 flex gap-4 md:!gap-14">
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-navy-700 dark:text-white">1077849284</p>
          <p className="text-sm font-normal text-gray-600">Cedula</p>
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-navy-700 dark:text-white">
            3213566554
          </p>
          <p className="text-sm font-normal text-gray-600">Celular</p>
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-navy-700 dark:text-white">
            32
          </p>
          <p className="text-sm font-normal text-gray-600">Edad</p>

        



        </div>
       
      </div>

      <button
          type="submit"
          className="w-full px-4 py-2 bg-blue-500 text-white font-bold rounded-md hover:bg-blue-600"
        >
          Editar informacion del Perfil 
        </button>

    </Card>
  );
};

export default Banner;
